import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const SuccessStories = () => {
  const stories = [
    {
      id: 1,
      name: "Familie van der Berg",
      location: "Amsterdam",
      service: "Zonnepanelen",
      savings: "€1.200",
      image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=400&h=300&fit=crop",
      quote: "Dankzij Verduurzaamwijzer hebben we de perfecte zonnepanelen installateur gevonden. Onze energierekening is met 80% gedaald!"
    },
    {
      id: 2,
      name: "Jan & Maria Smit",
      location: "Utrecht",
      service: "Warmtepomp",
      savings: "€800",
      image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=400&h=300&fit=crop",
      quote: "Uitstekende service en professionele installatie. Onze woning is nu volledig gasvrij en we besparen flink op de energiekosten."
    },
    {
      id: 3,
      name: "Petra Jansen",
      location: "Rotterdam",
      service: "Thuisbatterij",
      savings: "€600",
      image: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=400&h=300&fit=crop",
      quote: "Met onze nieuwe thuisbatterij zijn we energieonafhankelijk. Het platform maakte het kiezen van de juiste provider heel eenvoudig."
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-elevation-1 p-6 border border-border">
      <div className="text-center mb-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
          Succesverhalen van Klanten
        </h3>
        <p className="text-sm font-body text-muted-foreground">
          Ontdek hoe andere Nederlandse huiseigenaren besparen
        </p>
      </div>
      <div className="space-y-6">
        {stories?.map((story) => (
          <div key={story?.id} className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 rounded-full overflow-hidden">
                <Image
                  src={story?.image}
                  alt={`${story?.name} woning`}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center space-x-2 mb-1">
                <h4 className="text-sm font-heading font-medium text-foreground">
                  {story?.name}
                </h4>
                <span className="text-xs font-caption text-muted-foreground">
                  • {story?.location}
                </span>
              </div>
              <div className="flex items-center space-x-2 mb-2">
                <span className="inline-flex items-center px-2 py-1 rounded-md bg-primary/10 text-primary text-xs font-caption">
                  {story?.service}
                </span>
                <span className="inline-flex items-center space-x-1 text-success text-xs font-caption">
                  <Icon name="TrendingDown" size={12} />
                  <span>Besparing: {story?.savings}/jaar</span>
                </span>
              </div>
              <p className="text-xs font-body text-muted-foreground italic">
                "{story?.quote}"
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border text-center">
        <p className="text-xs font-body text-muted-foreground mb-2">
          Meer dan 15.000+ tevreden klanten in Nederland
        </p>
        <div className="flex items-center justify-center space-x-1">
          {[...Array(5)]?.map((_, i) => (
            <Icon key={i} name="Star" size={14} color="var(--color-warning)" className="fill-current" />
          ))}
          <span className="text-sm font-caption text-foreground ml-2">4.8/5</span>
        </div>
      </div>
    </div>
  );
};

export default SuccessStories;